import { mockExchangeBalances, mockExchangeTransactions } from '@/__mocks__';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} wallet
   */
  async initExchangeDetail({ commit, dispatch }, wallet) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchBalance', wallet),
      dispatch('fetchTransactions', wallet),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {String} wallet
   */
  async fetchBalance({ commit }) {
    try {
      commit('setBalance', mockExchangeBalances());
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {String} wallet
   */
  async fetchTransactions({ commit }, wallet) {
    try {
      commit('addTransactions', mockExchangeTransactions({ wallet }));
    }
    catch (error) {
      commit('setError', error);
    }
  },
};
